import { Box, Grid, Collapse, Card, Divider } from "@mui/material";
import FilterItems from "./FilterItems";
import ActiveFilters from "../../../../../Components/filters/ActiveFilters";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "employeeName",
      label: "Employee Name",
      value: submittedData.employeeName,
    },
    {
      type: "standard",
      id: "deviceImei",
      label: "Device ID",
      value: submittedData.deviceImei,
    },
    {
      type: "standard",
      id: "timePeriod",
      label: "Time Period",
      value: submittedData.timePeriod,
    },
    {
      type: "numericRange",
      id: "totalOrders",
      label: "Total Orders",
      minValue: submittedData.totalOrdersMin,
      maxValue: submittedData.totalOrdersMax,
    },
    {
      type: "numericRange",
      id: "orderLines",
      label: "Order Lines",
      minValue: submittedData.orderLinesMin,
      maxValue: submittedData.orderLinesMax,
    },
    {
      type: "numericRange",
      id: "totalItems",
      label: "Total Items",
      minValue: submittedData.totalItemsMin,
      maxValue: submittedData.totalItemsMax,
    },
  ];

  // Helper function to remove numeric range filters
  const handleRemoveNumericRange = (rangeId) => {
    if (rangeId === "totalOrders") {
      handleRemove("totalOrdersMin");
      handleRemove("totalOrdersMax");
    } else if (rangeId === "orderLines") {
      handleRemove("orderLinesMin");
      handleRemove("orderLinesMax");
    } else if (rangeId === "totalItems") {
      handleRemove("totalItemsMin");
      handleRemove("totalItemsMax");
    }
  };

  return (
    <>
      <Grid item xs={12}>
        <Collapse in={filterOpen}>
          <Card>
            <Box p={4}>
              <FilterItems
                filterData={filterData}
                handleChangeFilter={handleChangeFilter}
                handleFilter={handleFilter}
                handleClearFilters={handleClearFilters}
              />
            </Box>
          </Card>
        </Collapse>

        <ActiveFilters
          filterDefinitions={activeFilterDefinitions}
          onRemoveFilter={handleRemove}
          onRemoveNumericRange={handleRemoveNumericRange}
        />
      </Grid>
      <Divider sx={{ mb: 2 }} />
    </>
  );
};

export default Filter;
